import { render } from "./ProfileAttachments.vue?vue&type=template&id=62b9baa1&scoped=true"
import script from "./ProfileAttachments.vue?vue&type=script&lang=js"
export * from "./ProfileAttachments.vue?vue&type=script&lang=js"

import "./ProfileAttachments.vue?vue&type=style&index=0&id=62b9baa1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b9baa1"]])

export default __exports__